import React from 'react';
import { DatasetStatistics, StatusProps } from 'types/Dataset';
import CardIcon from 'components/card/CardIcon';
import EmptyFolderIcon from 'assets/icons/EmptyFolderIcon';
import TableIcon from 'assets/icons/TableIcon';

interface DatasetCardBodyProps {
    statistics: DatasetStatistics;
    status?: StatusProps;
}

const DatasetCardBody: React.FC<DatasetCardBodyProps> = ({
    statistics,
    status,
}) => {
    const cardIcons = [
        {
            logo: <EmptyFolderIcon className="fill-true-blue" />,
            amount: statistics.locations,
        },
        {
            logo: <TableIcon className="fill-true-blue" />,
            amount: statistics.tables,
        },
    ];

    return (
        <div className="flex justify-between items-center">
            <div className="flex gap-8">
                {cardIcons?.map((extra, index) => (
                    <div
                        className="flex items-center gap-8 p-4"
                        key={`${index}-logo-div`}
                    >
                        {extra.logo}
                        {extra.amount}
                    </div>
                ))}
            </div>
            {status && <CardIcon {...status} />}
        </div>
    );
};

export default DatasetCardBody;
